export const locale = {
    lang: 'en',
    data: {
        HELPER: {
            TIME: {
                FORMAT_DATE_WITH_HOUR: 'dd/MM/yyyy HH:mm',
                FORMAT_SECOND: '{{ seconds }} second ago',
                FORMAT_SECONDS: '{{ seconds }} seconds ago',
                FORMAT_MINUTE: '{{ minutes }} minute ago',
                FORMAT_MINUTES: '{{ minutes }} minutes ago',
                FORMAT_HOUR: '{{ hours }} hour ago',
                FORMAT_HOURS: '{{ hours }} hours ago',
            },
            LABEL: {
                DELIVERY_ROUTE_PERIOD: {
                    MORNING: 'Morning',
                    AFTERNOON: 'Afternoon',
                },
                PEOPLE_TYPE: {
                    CUSTOMER: 'Customer',
                    EMPLOYEE: 'Employee',
                    SUPPLIER: 'Supplier',
                },
                LABEL_TYPE: {
                    BROTHER_62_30: 'Brother 62x30 mm',
                    PIMACO_28_51: 'Pimaco 28x51 mm (SLP-MRL)',
                    PIMACO_28_89: 'Pimaco 28x89 mm (SLP-2RLH)',
                    PIMACO_36_89: 'Pimaco 36x89 mm (SLP-2RLE)',
                    PIMACO_54_101: 'Pimaco 54x101 mm (SLP-SRL)',
                    ZEBRA_80_50: 'Zebra 80x50 mm',
                    ZEBRA_50_30: 'Zebra 50x30 mm',
                    ZEBRA_50_30_X2: 'Zebra 50x30 mm - 2 columns',
                },
                LABEL_IDENTIFICATION_CODE: {
                    QR_CODE: 'QR Code',
                    BAR_CODE: 'Bar Code',
                },
                LABEL_IDENTIFICATION_TYPE: {
                    ORDER: 'Order Data',
                    ADDRESS: 'Address',
                    ITEMS: 'Items',
                },
                OUTSOURCE_STATUS: {
                    PENDING: 'Sent',
                    FINISH: 'Finished',
                    DELAYED: 'Delayed',
                },
                EQUIPMENT_TYPE: {
                    SCANNER: 'Scanner',
                    MILLING: 'Milling',
                    PRINTER: 'Printer',
                    FURNACE: 'Furnace',
                    OTHER: 'Other',
                },
                ORDER_ITEM_TYPES: {
                    PRODUCT: 'Product',
                    SERVICE: 'Service',
                },
                COMMISSION_INCLUDE_TYPE: {
                    ORDER: 'Completed orders',
                    STAGE: 'Completed stages',
                },
                COMMISSION_CALC_BASIS: {
                    GROSS_VALUE: 'Gross service value',
                    NET_VALUE: 'Net service value',
                },
                CUSTOMER_STATUS: {
                    ACTIVE: {
                        ACTIVE: 'Active',
                        TEMPORARY: 'Temporarily active',
                    },
                    LEAD: 'Prospect',
                    INACTIVE: 'Inactive',
                    BLOCKED: 'Blocked',
                },
                DENTISTRY_DENTAL_NOTATION: {
                    FDI_NOTATION: 'FDI Notation',
                    UNIVERSAL_SYSTEM: 'Universal System',
                    PALMER_NOTATION: 'Palmer Notation',
                },
                INVOICE_TYPE: {
                    BIWEEKLY: 'Biweekly',
                    MONTHLY: 'Monthly',
                },
                REGISTRATION_TYPE: {
                    PERSONAL: 'Individual',
                    BUSINESS: 'Legal Entity',
                },
                PHONE_TYPES: {
                    HOME: 'Home',
                    MOBILE: 'Mobile',
                    WORK: 'Work',
                    OTHER: 'Other',
                },
                EMPLOYEE_STATUS: {
                    ACTIVE: 'Active',
                    INACTIVE: 'Inactive',
                },
                KIWID_PLAN_SOFTWARE_LEVEL: {
                    PRO: 'Pro',
                    BASIC: 'Basic',
                    ESSENTIAL: 'Essential',
                },
                SUPPLIER_STATUS: {
                    ACTIVE: 'Active',
                    INACTIVE: 'Inactive',
                },
                SUPPLIER_TYPES: {
                    BUSINESS: 'Legal',
                    NATURAL: 'Individual',
                },
                PAYMENT_METHOD: {
                    CASH: 'Cash',
                    CHECK: 'Check',
                    ACCOUNT_CREDIT: 'Account credit',
                    BANK_SLIP: 'Bank slip',
                    CREDIT_CARD: 'Credit card',
                    DEBIT_CARD: 'Debit card',
                    ONLINE_CARD: 'Online credit card',
                    ONLINE_BANK_SLIP: 'Online bank slip',
                    TRANSFER: 'Transfer',
                    DIRECT_DEBIT: 'Direct debit',
                    ACCOUNT_TRANSFER: 'Account transfer',
                    PIX: 'Pix',
                    NONE: '-',
                },
                ORDER_STATUS: {
                    DRAFT: 'Draft',
                    NEW: 'New',
                    APPROVAL: 'Approval',
                    PENDING: 'Pending',
                    PRODUCTION: 'Production',
                    PROOF: 'Proof',
                    DELAYED: 'Delayed',
                    FINISHED: 'Finished',
                    DELIVERED: 'Delivered',
                    CANCELLED: 'Cancelled',
                    SUSPENDED: 'Suspended',
                },
                PRODUCTION_STATUS: {
                    PENDING: 'Pending',
                    ACTIVE: 'Started',
                    FINISHED: 'Finished',
                    CANCELED: 'Cancelled',
                },
                GENDER: {
                    MALE: 'Male',
                    FEMALE: 'Female',
                    NOT_BINARY: 'Non-binary',
                },
                ORDER_TYPE: {
                    ORDER: 'Order',
                    QUOTATION: 'Quotation',
                },
                PHONE: {
                    HOME: 'Home',
                    MOBILE: 'Mobile',
                    WORK: 'Work',
                    OTHER: 'Other',
                },
                INVOICE_STATUS: {
                    OPEN: 'Open',
                    CLOSED: 'Closed',
                    PAID: 'Paid',
                    CANCELLED: 'Cancelled',
                },
                RECEIVABLE_STATUS: {
                    PENDING: 'Pending',
                    CANCELLED: 'Cancelled',
                    PAID: 'Paid',
                    REFUSED: 'Refused',
                    REFUNDED: 'Refunded',
                    DISPUTE: 'In dispute',
                    CHARGEBACK: 'Chargeback',
                },
                RECEIVABLE_TOOLTIP_STATUS: {
                    PENDING: 'Pending transaction',
                    OVERDUE: 'Overdue transaction',
                    DUE_DATE_TODAY: 'Transaction due today',
                    CANCELLED: 'Cancelled transaction',
                    PAID: 'Paid transaction',
                    REFUSED: 'Refused transaction',
                    REFUNDED: 'Refunded transaction',
                    DISPUTE: 'Transaction in chargeback dispute',
                    CHARGEBACK: 'Transaction with chargeback',
                },
                CREDIT_CARD_BRAND: {
                    VISA: 'Visa',
                    MASTERCARD: 'Mastercard',
                    AMERICAN_EXPRESS: 'American express',
                    ELO: 'Elo',
                    HIPERCARD: 'hipercard',
                    HIPER: 'Hiper',
                    DISCOVER: 'Discover',
                    DINERS: 'Diners',
                    AURA: 'Aura',
                    JCB: 'Jcb',
                    CABAL: 'Cabal',
                    BANESCARD: 'Banescard',
                },
                TRANSFER_INTERVAL: {
                    DAILY: 'Daily',
                    WEEKLY: 'Weekly',
                    MONTHLY: 'Monthly',
                },
                LOCATION_STATUS: {
                    TRIAL_EXPIRES: 'TRIAL EXPIRES IN {{ days }} DAYS. GET IT NOW!',
                    TRIAL_EXPIRES_ONE_DAY: 'TRIAL EXPIRES IN {{ days }} DAY. GET IT NOW!',
                    LOCATION_TRIAL_EXPIRES: '{{ locationName }}: TRIAL EXPIRES IN {{ days }} DAYS. GET IT NOW!',
                    LOCATION_TRIAL_EXPIRES_ONE_DAY: '{{ locationName }}: TRIAL EXPIRES IN {{ days }} DAY. GET IT NOW!',
                    DEBTOR: 'YOUR PAYMENT IS OVERDUE. CHECK NOW!',
                    LOCATION_DEBTOR: '{{ locationName }}: YOUR PAYMENT IS OVERDUE. CHECK NOW!',
                    TRIAL_ENDED: 'YOUR TRIAL PERIOD HAS ENDED. GET IT NOW!',
                    LOCATION_TRIAL_ENDED: '{{ locationName }}: YOUR TRIAL PERIOD HAS ENDED. GET IT NOW!',
                },
                STOCK_KEY: {
                    NEW_STOCK: 'New stock',
                    RETURN: 'Return',
                    TRANSFER: 'Transfer',
                    INTERNAL_USE: 'Internal use',
                    DAMAGED: 'Damaged',
                    OUT_OF_DATE: 'Expired',
                    ADJUSTMENT: 'Adjustment',
                    LOST: 'Lost',
                    REMAKE: 'Remake',
                    OTHER: 'Other',
                    STOCK_ENABLED: 'Stock monitoring enabled',
                    STOCK_DISABLED: 'Stock monitoring disabled',
                    SALE: 'Order ',
                    ORDER_REOPEN: 'Reopened order ',
                    ORDER_CANCELLED: 'Cancelled order ',
                    ORDER_DELETED: 'Deleted order ',
                    ITEM_DELETED: 'Deleted order item ',
                    INVENTORY_ORDER_CANCELLED: 'Cancelled purchase ',
                    INVENTORY_ORDER_DELETED: 'Deleted purchase ',
                },
                DELIVERY_ROUTE_STATUS: {
                    PENDING: 'Scheduled',
                    SCHEDULED: 'Released',
                    FINISHED: 'Delivered',
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Cash payment',
                        CHECK: 'Check payment',
                        ACCOUNT_CREDIT: 'Account credit payment',
                        BANK_SLIP: 'Bank slip payment',
                        CREDIT_CARD: 'Credit card payment',
                        CREDIT_CARD_FREQUENCY: 'Installment credit card payment',
                        DEBIT_CARD: 'Debit card payment',
                        ONLINE_CARD: 'Online credit card payment',
                        ONLINE_BANK_SLIP: 'Online bank slip payment',
                        CANCEL: {
                            BANK_SLIP: 'Bank slip cancellation',
                            CHECK: 'Check cancellation',
                            CASH: 'Cash cancellation',
                            ACCOUNT_CREDIT: 'Account credit cancellation',
                            CREDIT_CARD: 'Credit card cancellation',
                            DEBIT_CARD: 'Debit card cancellation',
                            ONLINE_CARD: 'Online credit card cancellation',
                            ONLINE_BANK_SLIP: 'Online bank slip cancellation',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Online card refund',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Online card charged back',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Installment payment',
                        CASH: 'Cash installment payment',
                        CHECK: 'Check installment payment',
                        ACCOUNT_CREDIT: 'Account credit installment payment',
                        BANK_SLIP: 'Bank slip installment payment',
                        CREDIT_CARD: 'Credit card installment payment',
                        DEBIT_CARD: 'Debit card installment payment',
                        ONLINE_CARD: 'Online credit card installment payment',
                        ONLINE_BANK_SLIP: 'Online bank slip installment payment',
                        CANCEL: {
                            BANK_SLIP: 'Cancelled bank slip installment',
                            CHECK: 'Cancelled check installment',
                            CASH: 'Cancelled cash installment',
                            ACCOUNT_CREDIT: 'Cancelled account credit installment',
                            CREDIT_CARD: 'Cancelled credit card installment',
                            DEBIT_CARD: 'Cancelled debit card installment',
                            ONLINE_CARD: 'Cancelled online credit card installment',
                            ONLINE_BANK_SLIP: 'Cancelled online bank slip installment',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Refunded online card installment',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Online card installment charged back',
                        },
                    },
                },
                KEY_MOVEMENTS: {
                    OTHER: 'Other',
                    DISCOUNT: 'Discount',
                    REFUND: 'Refund',
                    ORDER: 'Order',
                    PAYMENT: 'Payment',
                    INITIAL_BALANCE: 'Initial balance',
                },
                MEDIA_TYPE: {
                    PRIVATE: 'Private',
                    PUBLIC: 'Public',
                },
                ACCOUNT_BANK: {
                    CHECKING_ACCOUNT: 'Checking account',
                    SAVINGS_ACCOUNT: 'Savings account',
                    CASH_ACCOUNT: 'Internal account',
                    CREDIT_CARD_ACCOUNT: 'Credit card',
                    DIGITAL_ACCOUNT: 'Digital account',
                },
                PIX_KEY: {
                    DOCUMENT: 'CPF/CNPJ',
                    PHONE: 'Phone',
                    EMAIL: 'E-mail',
                    RANDOM: 'Random',
                },
                MOVEMENT_PAYMENT_DESCRIPTION: {
                    PAYMENT: 'Payment',
                    REFUND_PAYMENT: 'Refund payment',
                    CANCEL: 'Cancelled',
                    GENERATE: 'Generated',
                    PAYMENT_CASH: 'Cash payment',
                    PAYMENT_INSTALLMENT: 'Payment {{ installment }}x',
                    PAYMENT_INSTALLMENT_DESCRIPTION: {
                        DEFAULT: 'Payment in {{ installment }}x',
                        CANCELLED: 'Cancelled: Payment installment {{ installmentNumber }}',
                    },
                    REFUND: 'Refund',
                },
                MOVEMENT_PAYMENT_SUB_DESCRIPTION: {
                    DATE_FORMAT: 'dd/MM/yyyy',
                    ACCOUNT_NAME: 'Account: {{ accountName }}',
                    NF_NAME: 'NF: {{ nfName }}',
                    DUE_DATE: 'Due: {{ dueDate }}',
                    CHECK: {
                        NUMBER: 'Number',
                        NAME: 'Name',
                        DATE: 'Date',
                    },
                },
                RELATIVE_TYPES: {
                    PARTNER: 'Husband, wife',
                    FATHER: 'Father',
                    MOTHER: 'Mother',
                    BROTHER_SISTER: 'Brother/Sister',
                    SON_DAUGHTER: 'Son/Daughter',
                    FRIEND: 'Friend',
                    OTHER: 'Other',
                },
                INVENTORY_ORDER_STATUS: {
                    DRAFT: 'Draft',
                    APPROVAL: 'Under approval',
                    ORDERED: 'Ordered',
                    PARTIAL: 'Partial',
                    RECEIVED: 'Received',
                    CANCELLED: 'Cancelled',
                },
                LAMBDA: {
                    REPORT_ORDER_EQUIPMENT_DETAIL: 'Equipment',
                    REPORT_ORDER_EQUIPMENT_BY_EQUIPMENT: 'Equipment',
                    REPORT_ORDER_EQUIPMENT_BY_STAGE: 'Equipment',
                    REPORT_ORDER_DETAILED: 'Detailed Orders',
                    REPORT_ORDER_FINISHED: 'Finished orders',
                    REPORT_ORDER_PENDING: 'Pending orders',
                    REPORT_FINANCIAL_PAYMENT_LINK: 'Payment link',
                    REPORT_FINANCIAL_DEBIT_CREDIT_BALANCE: 'Debtors / Creditors',
                    REPORT_FINANCIAL_RECEIPT: 'Issued Receipts',
                    REPORT_ORDER_OUTSOURCE: 'Outsourced orders',
                    REPORT_ORDER_RATING: 'Order ratings',
                    REPORT_SERVICE_PRODUCTION_BY_MONTH: 'Service production by month',
                    REPORT_EMPLOYEE_PRODUCTION_SCHEDULE: 'Employee production schedule',
                    REPORT_SERVICE_STAGE: 'Services and Stages',
                    APP_PRICE_TABLE: 'Price table',
                    APP_PRODUCTION_SCHEDULE: 'Production schedule',
                    REPORT_FINANCIAL_REVENUE: 'Revenue',
                    REPORT_INVENTORY_ORDER_DETAIL: 'Detailed Purchases',
                    REPORT_INVENTORY_ORDER_PRODUCT: 'Purchases by Products',
                    REPORT_INVENTORY_ORDER_SUPPLIER: 'Purchases by Suppliers',
                    REPORT_INVENTORY_ORDER_PERIOD: 'Purchases by Period',
                },
            },
            PDF: {
                DATE_FORMAT: 'dd/MM/yyyy',
                DATETIME_FORMAT: 'dd/MM/yyyy HH:mm:ss',
                USER: 'User',
                RECEIVABLES: {
                    ACCOUNT: 'Bank account',
                    EXPENSE: 'Expenses',
                    INCOME: 'Income',
                    RECURRENT: 'Recurring',
                    TABLE: {
                        THEAD: {
                            DATE: 'Date',
                            PEOPLE_INCOME: 'Received from',
                            PEOPLE_EXPENSE: 'Paid to',
                            DESCRIPTION: 'Description',
                            EXTERNAL_INVOICE_NUMBER: 'Invoice No.',
                            GROSS_VALUE: 'Gross value',
                            NET_VALUE: 'Net value',
                            DUE_DATE: 'Due date',
                            PAYMENT_METHOD_EXPENSE: 'Payment method',
                            PAYMENT_METHOD_INCOME: 'Payment method',
                            STATUS: 'Status',
                        },
                        TBODY: {
                            ACCRUAL_DATE: 'Accrual: {{date}}',
                        },
                    },
                    RESUME_TOTAL: {
                        GROSS_VALUE: 'Gross value',
                        TAX: 'Fees',
                        RATE: 'Interest',
                        DISCOUNT: 'Discounts',
                        NET_VALUE: 'Net value',
                        PAID_INCOME: 'Total received',
                        UNPAID_INCOME: 'Total to receive',
                        PAID_EXPENSE: 'Total paid',
                        UNPAID_EXPENSE: 'Total to pay',
                    },
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Cash payment',
                        CHECK: 'Check payment',
                        ACCOUNT_CREDIT: 'Account credit payment',
                        BANK_SLIP: 'Bank slip payment',
                        CREDIT_CARD: 'Credit card payment',
                        CREDIT_CARD_FREQUENCY: 'Installment credit card payment',
                        DEBIT_CARD: 'Debit card payment',
                        ONLINE_CARD: 'Online credit card payment',
                        ONLINE_BANK_SLIP: 'Online bank slip payment',
                        CANCEL: {
                            BANK_SLIP: 'Bank slip cancellation',
                            CHECK: 'Check cancellation',
                            CASH: 'Cash cancellation',
                            ACCOUNT_CREDIT: 'Account credit cancellation',
                            CREDIT_CARD: 'Credit card cancellation',
                            DEBIT_CARD: 'Debit card cancellation',
                            ONLINE_CARD: 'Online credit card cancellation',
                            ONLINE_BANK_SLIP: 'Online bank slip cancellation',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Online card refund',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Online card charged back',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Installment payment',
                        // EMPTY_COUNT: 'Pagamento parcelado em {{installmentTotal}}x',
                        CASH: 'Cash installment payment',
                        CHECK: 'Check installment payment',
                        ACCOUNT_CREDIT: 'Account credit installment payment',
                        BANK_SLIP: 'Bank slip installment payment',
                        CREDIT_CARD: 'Credit card installment payment',
                        DEBIT_CARD: 'Debit card installment payment',
                        ONLINE_CARD: 'Online credit card installment payment',
                        ONLINE_BANK_SLIP: 'Online bank slip installment payment',
                        CANCEL: {
                            BANK_SLIP: 'Cancelled bank slip installment',
                            CHECK: 'Cancelled check installment',
                            CASH: 'Cancelled cash installment',
                            ACCOUNT_CREDIT: 'Cancelled account credit installment',
                            CREDIT_CARD: 'Cancelled credit card installment',
                            DEBIT_CARD: 'Cancelled debit card installment',
                            ONLINE_CARD: 'Cancelled online credit card installment',
                            ONLINE_BANK_SLIP: 'Cancelled online bank slip installment',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Refunded online card installment',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Online card installment charged back',
                        },
                    },
                },
            },
            ERROR_INTERCEPTOR: {
                SYSTEM_ERROR: {
                    CONFIRM: {
                        BUTTONS: {
                            CONFIRM: 'Confirm',
                            CANCEL: 'Cancel',
                        },
                    },
                    WARNING: {
                        BUTTONS: {
                            CONFIRM: 'I understand',
                        },
                    },
                },
            },
        },
    },
};